import React from 'react'
import { Link } from 'react-router-dom'
import Card from '../Card'
import S from '../Card.style'

export interface LibraryCardWrapperProps {
	linkUrl?: string
	children: any
}

export interface LibraryCardProps {
	className?: string
	name: string
	image: string
	linkUrl?: string
	isHorizontal?: boolean
}

const LibraryCardWrapper = ({ linkUrl, children }: LibraryCardWrapperProps) => {
	if (linkUrl) return <Link to={linkUrl}>{children}</Link>
	return children
}

export const LibraryCard = ({
	className = '',
	name,
	image,
	linkUrl,
	isHorizontal = false,
}: LibraryCardProps) => {
	return (
		<Card isCenteredText>
			<div
				data-testid="LibraryCard"
				className={`w-full [&_a:hover]:no-underline ${className}`}
			>
				<LibraryCardWrapper linkUrl={linkUrl}>
					<div className={isHorizontal ? 'flex' : ''}>
						<div
							className={
								isHorizontal
									? 'flex-[250px_0_0] flex flex-col items-center justify-center -m-4 mr-0 p-4'
									: ''
							}
						>
							<S.Title>{name}</S.Title>
						</div>
						<div>
							<S.Image
								className={isHorizontal ? '-m-4 ml-0 pt-[25%] flex-1' : ''}
								style={!isHorizontal ? { margin: '1rem -1rem -1rem -1rem' } : undefined}
								src={image}
							/>
						</div>
					</div>
				</LibraryCardWrapper>
			</div>
		</Card>
	)
}

export default LibraryCard
